import {  Table, TableCell,  TableHead, TableContainer, TableBody, TableRow,  useTheme,alpha } from "@mui/material";
import React, { useState } from "react";
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";
import CustomTableContainer from "../../../components/table/CustomTableContainer";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";
import TableFilterRow from "../../../components/table/TableFilterRow";
import CustomPagination from "../../../components/table/CustomPagination";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";

const ViewStorageLocationReportBySONumber = ({ reportDetail, loadingOrderItemDet }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // message Process

    const [isDataLoaded, setIsDataLoaded] = useState(false);

    const [soNumber, setSONumber] = useState('');
    const [editShiftAssignmentID, setShiftAssignmentID] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [productList, setProductList] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');
    const [viewList, setViewList] = useState(false);
    const [openDateRangeDialog, setOpenDateRangeDialog] = useState(false);

    const handleViewDataBySONumber = () => {
        const SaveData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_so_number: soNumber,
        }

        callApi(API_ENDPOINTS.PRODUCTION_VIEW_STORAGE_LOCATION, 'POST', { 'Content-Type': 'application/json' }, SaveData)
            .then(data => {
                if (data && data.length > 0) {
                    setProductList(data);
                    setViewList(true);
                    setSelectedRows([]);
                }
                else {
                    setProductList([]);
                    setViewList(false);
                    setSelectedRows([]);
                }
            })
            .catch(error => {
                alert(error.message);
            });
    }


    const [filters, setFilters] = useState({
        rcustomer_name: '',
        rconsignee_name: '',
        rquality: '',
        rgsm: '',
        rwidth: '',
        rlength: '',
        rgrade: '',
        rstorage_location: '',
        rplanning_number: '',
        rsales_office: '',
        rdestination: '',
    });
    const handleOpen = () => {
        setOpenDateRangeDialog(true);
    };

    const handleClose = () => {
        setOpenDateRangeDialog(false);
    };

    // const handleFilterChange = (event) => {
    //     const { name, value } = event.target;
    //     setFilters({ ...filters, [name]: value });
    // };
    const handleFilterChange = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };

    const filteredData = reportDetail.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelectedRows = reportDetail.map((row) => row.id_product);
            setSelectedRows(newSelectedRows);
            return;
        }
        setSelectedRows([]);
    };
    const handleRowCheckboxClick = (event, rowId) => {
        const selectedIndex = selectedRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows.slice(1);
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelectedRows = selectedRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows.slice(0, selectedIndex),
                ...selectedRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedRows(newSelectedRows);


    };

    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;

    const [recordsPerPage, setRecordsPerPage] = useState(20); // Records per page
    const [currentPage, setCurrentPage] = useState(1);

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const pageCount = Math.ceil(filteredData.length / recordsPerPage);

    const uniqueValues = {
        order_no: [...new Set(reportDetail.map(row => row.order_no))],
        rcustomer_name: [...new Set(reportDetail.map(row => row.rcustomer_name))],
        rconsignee_name: [...new Set(reportDetail.map(row => row.rconsignee_name))],
        rquality: [...new Set(reportDetail.map(row => row.rquality))],
        rgsm: [...new Set(reportDetail.map(row => row.rgsm))],
        rgrade: [...new Set(reportDetail.map(row => row.rgrade))],
        rstorage_location: [...new Set(reportDetail.map(row => row.rstorage_location))],
      
    };

    // Get the records for the current page
    const currentRecords = filteredData.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );

    const columns = ['order_no', 'rorder_date', 'rcustomer_name', 'rconsignee_name', 'rquality', 'rgsm', 'rwidth', 'rlength', 'rgrade', 'rorder_qty', 'rach_qty', 'rfg_qty', 'rreel_stock', 'rno_of_reams_per_bundle', 'rno_of_ream','rream_weight', 'rnumber_of_bundle', 'rnumber_of_loose', 'rream_stock', 'rstorage_location', 'rplanning_number', 'rstorage_date', 'rsales_office', 'rdestination'];

    const autoCompleteColumns = ['order_no', 'rcustomer_name', 'rconsignee_name', 'rquality', 'rgsm', 'rgrade', 'rstorage_location', ];

    const totals = {
        rorder_qty: filteredData.reduce((sum, r) => sum + (parseFloat(r.rorder_qty) || 0), 0),
        rach_qty: filteredData.reduce((sum, r) => sum + (parseFloat(r.rach_qty) || 0), 0),
        rfg_qty: filteredData.reduce((sum, r) => sum + (parseFloat(r.rfg_qty) || 0), 0),
        rreel_stock: filteredData.reduce((sum, r) => sum + (parseFloat(r.rreel_stock) || 0), 0),
        rno_of_ream: filteredData.reduce((sum, r) => sum + (parseFloat(r.rno_of_ream) || 0), 0),
        rream_weight: filteredData.reduce((sum, r) => sum + (parseFloat(r.rream_weight) || 0), 0),
        rnumber_of_bundle: filteredData.reduce((sum, r) => sum + (parseFloat(r.rnumber_of_bundle) || 0), 0),
        rnumber_of_loose: filteredData.reduce((sum, r) => sum + (parseFloat(r.rnumber_of_loose) || 0), 0),
        rream_stock: filteredData.reduce((sum, r) => sum + (parseFloat(r.rream_stock) || 0), 0),
    };


    return (
        <>

            <ResponsiveBox
                customMaxHeight={{
                    xs: '60vh',  // Custom value for extra small devices
                    sm: '65vh',  // Custom value for small devices
                    md: '70vh',  // Custom value for medium devices
                    lg: '60vh',  // Custom value for large devices
                    xl: '75vh',  // Custom value for extra large devices
                }}>
                <CustomTableContainer colors={colors}>

                    <TableContainer>
                        {loadingOrderItemDet ? (
                            <SkeletonTableLoader rows={5} columns={11} />
                        ) : (
                            <Table>
                                <TableHead >
                                    <TableRow >
                                        {/* <TableCell>
                                            <Checkbox size="small" style={{ color: "secondary" }}
                                                indeterminate={selectedRows.length > 0 && selectedRows.length < filteredData.length}
                                                checked={selectedRows.length === filteredData.length}
                                                onChange={handleSelectAllClick}
                                            />
                                        </TableCell> */}
                                        {/* <TableCell>NO</TableCell> */}
                                
                                          <TableCell  sx={{ textAlign: "center", minWidth: 145, whiteSpace: "nowrap" }}>ORDER ID</TableCell>
                                        <TableCell  sx={{ textAlign: "center", minWidth: 100, whiteSpace: "nowrap" }}>Order DATE</TableCell>
                                        <TableCell sx={{ textAlign: "center", minWidth: 250, whiteSpace: "nowrap" }}>CUSTOMER NAME</TableCell>
                                        <TableCell sx={{ textAlign: "center", minWidth: 250, whiteSpace: "nowrap" }}>CONSIGNEE NAME</TableCell>
                                        <TableCell  sx={{ textAlign: "center", minWidth: 140, whiteSpace: "nowrap" }}>QUALITY</TableCell>
                                        <TableCell sx={{ textAlign: "center",}}>GSM</TableCell>
                                        <TableCell>WIDTH</TableCell>
                                        <TableCell>LENGTH</TableCell>
                                        <TableCell sx={{ textAlign: "center",}}>GRADE</TableCell>
                                        <TableCell  sx={{ textAlign: "center", }}>ORDER QTY</TableCell>
                                        <TableCell sx={{ textAlign: "center", }}>ACHIEVED QTY</TableCell>
                                        <TableCell>FG QTY</TableCell>
                                        <TableCell sx={{ textAlign: "center", }}>REEL STOCK</TableCell>
                                        <TableCell  sx={{ textAlign: "center", minWidth: 140, whiteSpace: "nowrap" }}>NO OF REAM PER BUNDLE</TableCell>
                                        <TableCell sx={{ textAlign: "center", minWidth: 100, whiteSpace: "nowrap" }}>NO OF REAM</TableCell>
                                        <TableCell>REAM WEIGHT</TableCell>
                                        <TableCell>NO OF BUNDLE</TableCell>
                                        <TableCell>NO OF LOOSE</TableCell>
                                        <TableCell>REAM STOCK</TableCell>
                                        <TableCell>LOCATION</TableCell>
                                        <TableCell>PLANNING NO</TableCell>
                                        <TableCell sx={{ textAlign: "center", minWidth: 100, whiteSpace: "nowrap" }}>FG RECEVING DATE</TableCell>
                                        <TableCell>SALES OFFICE</TableCell>
                                        <TableCell>DESTINATION</TableCell>
                                    </TableRow>

                                    <TableFilterRow
                                        columns={columns}
                                        filters={filters}
                                        handleFilterChange={handleFilterChange}
                                        uniqueValues={uniqueValues}
                                        autoCompleteColumns={autoCompleteColumns}
                                    />

                                    <TableRow sx={{ backgroundColor: colors.primary[400], height: 10 }}>
                                        <TableCell colSpan={9} sx={{ fontWeight: 'bold', textAlign: 'right' }}>TOTAL </TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.rorder_qty}</TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.rach_qty}</TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.rfg_qty.toFixed(1)}</TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.rreel_stock}</TableCell>
                                        <TableCell></TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.rno_of_ream}</TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.rream_weight.toFixed(1)}</TableCell>
                                      
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.rnumber_of_bundle}</TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.rnumber_of_loose}</TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.rream_stock.toFixed(1)}</TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {currentRecords.map((s,index) => (
                                        <React.Fragment key={s.id}>
                                            <TableRow  sx={{
         backgroundColor:
      index % 2 === 0
        ? theme.palette.background.default
        : alpha(theme.palette.action.hover, 0.04), // slightly darker

        }}>
                                                {/* <TableCell>
                                                    <Checkbox
                                                        size="small"
                                                        checked={isSelected(s.order_no)}
                                                        onChange={(event) => handleRowCheckboxClick(event, s.order_no)}
                                                    />
                                                </TableCell> */}
                                                {/* <TableCell>{s.id_product}</TableCell> */}
                                                <TableCell>{s.order_no}</TableCell>
                                                <TableCell>{s.rorder_date || ''}</TableCell>
                                                <TableCell>{s.rcustomer_name}</TableCell>
                                                <TableCell>{s.rconsignee_name}</TableCell>
                                                <TableCell>{s.rquality}</TableCell>
                                                <TableCell  sx={{ textAlign: "right", }}>{s.rgsm}</TableCell>
                                                <TableCell sx={{ textAlign: "right", }}>{s.rwidth}</TableCell>
                                                <TableCell sx={{ textAlign: "right", }}>{s.rlength}</TableCell>
                                                <TableCell>{s.rgrade}</TableCell>
                                                <TableCell sx={{ textAlign: "right", }}>{s.rorder_qty || 0}</TableCell>
                                                <TableCell sx={{ textAlign: "right", }}>{s.rach_qty}</TableCell>
                                                <TableCell sx={{ textAlign: "right", }}>{s.rfg_qty}</TableCell>
                                                <TableCell sx={{ textAlign: "right", }}>{s.rreel_stock || 0}</TableCell>
                                                <TableCell sx={{ textAlign: "right", }}>{s.rno_of_reams_per_bundle}</TableCell>
                                                <TableCell sx={{ textAlign: "right", }}>{s.rno_of_ream}</TableCell>
                                                <TableCell sx={{ textAlign: "right", }}>{s.rream_weight}</TableCell>
                                                <TableCell sx={{ textAlign: "right", }}>{s.rnumber_of_bundle}</TableCell>
                                                <TableCell sx={{ textAlign: "right", }}>{s.rnumber_of_loose}</TableCell>
                                                <TableCell sx={{ textAlign: "right", }}>{s.rream_stock}</TableCell>
                                                <TableCell>{s.rstorage_location}</TableCell>
                                                <TableCell sx={{ textAlign: "right", }}>{s.rplanning_number}</TableCell>
                                                <TableCell>{s.rstorage_date}</TableCell>
                                                <TableCell>{s.rsales_office}</TableCell>
                                                <TableCell>{s.rdestination}</TableCell>
                                            </TableRow>
                                        </React.Fragment>
                                    ))}

                                </TableBody>
                            </Table>
                        )}
                      
                    </TableContainer>
                     
                </CustomTableContainer>
            </ResponsiveBox>
             <CustomPagination pageCount={pageCount} currentPage={currentPage} onPageChange={handlePageChange} />

        </>
    )
}
export default ViewStorageLocationReportBySONumber;